import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios nếu chưa có
import CartItemTable from "../cart/CartItemTable";
import { FarzaaContext } from "../../context/FarzaaContext";
import userApi from "../../api/userApi";

const CartModal = ({ cartArray }) => {
  const [cartItems, setCartItems] = useState(cartArray);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { showCart, handleCartClose } = useContext(FarzaaContext);

  useEffect(() => {
    fetchCartPrices(cartArray);
  }, [cartArray]);

  // Hàm gọi API addToCart và cập nhật cartItems
  const fetchCartPrices = async (cartArray) => {
    setLoading(true);
    setError(null);

    const requestData = cartArray.map(item => ({
      productDetailID: item.productDetailId,
      quantity: item.quantity,
    }));
    try {
      const response = await userApi.addToCart(requestData);
      console.log("API Response:", response);

      // Kiểm tra nếu response đã chứa trực tiếp items
      const items = response.items || (response.data && response.data.items);

      if (items) {
        // Đồng bộ thông tin từ API với cartItems
        const updatedCart = cartArray.map(item => {
          const apiItem = items.find(apiItem => apiItem.productDetailId === item.productDetailId);
          return apiItem
            ? {
              ...item,
              productDetailName: apiItem.productDetailName,
              priceOfUnit: apiItem.priceOfUnit,
              totalPrice: apiItem.totalPrice,
              finalPrice: apiItem.finalPrice,
              quantity: apiItem.quantity,
            }
            : item;
        });

        setCartItems(updatedCart);
        console.log("Updated Cart:", updatedCart);
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (err) {
      console.error("Error fetching cart prices:", err);
      setError("Failed to load cart prices. Please try again.");
    } finally {
      setLoading(false);
    }



  };


  const handleQuantityChange = async (productDetailId, newQuantity) => {
    const updatedCart = cartItems.map(item =>
      item.productDetailId === productDetailId
        ? { ...item, quantity: newQuantity }
        : item
    );

    setCartItems(updatedCart);

    await fetchCartPrices(updatedCart);
  };

  const handleRemoveItem = async (productDetailId) => {
    const updatedCart = cartItems.filter(item => item.productDetailId !== productDetailId);
    setCartItems(updatedCart);

    await fetchCartPrices(updatedCart);
  };

  const closeAndNavigate = (path) => {
    handleCartClose();
    navigate(path);
  };

  return (
    <>
      <div
        className={`overlay ${showCart ? "open" : ""}`}
        role="button"
        onClick={handleCartClose}
      ></div>
      <div
        className={`cart-area cart-area-modal ${showCart ? "open" : ""}`}
        id="cart-area-modal"
      >
        <div className="cart__header">
          <h3 className="cart__title">Shopping Cart</h3>
          <button className="cart-area-modal-close-btn" onClick={() => closeAndNavigate('/')}>
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>
        <div className="cart__body">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-container">
              <CartItemTable
                cartArray={cartItems}
                remove={handleRemoveItem}
                quantity={handleQuantityChange}
              />
            </div>
          )}

          {cartItems.length === 0 && !loading ? (
            <div className="cart-left-actions d-flex justify-content-end">
              <button
                onClick={() => closeAndNavigate("/")}
                className="fz-1-banner-btn update-cart-btn"
              >
                Go to Shop
              </button>
            </div>
          ) : (
            <div className="cart-left-actions d-flex justify-content-between">
              <button
                onClick={() => closeAndNavigate("/cart")}
                className="fz-1-banner-btn update-cart-btn"
              >
                View Full Cart
              </button>
              <button
                onClick={() => closeAndNavigate("/checkout")}
                className="fz-1-banner-btn update-cart-btn"
              >
                Proceed to Checkout
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CartModal;
